<template lang="pug">
.Territory
  app-header
    b.Menu-title КОНТРОЛЬ
  .Territory-menu.Menu.Control-top-panel
    .Menu-left.Control-layer-count
      .Menu-item
        span Документов: {{ list.length }}
    text-box.Control-search-text-box(
      placeholder='Введите название документа для поиска',
      :value='searchText',
      @valueChanged='searchTextChanged'
    )
    .Menu-right.Control-add-button-wrapper(v-if='!isPublicWs && canEditWs && $store.getters.permissions.canCreateControl')
      .Menu-item.Menu-link
        a.Pointer(@click='addDocument')
          i.Icon.IconPlus
          span добавить документ
  .Territory-main
    .Territory-spinner
      fade-loader.Spinner(
        :loading='isLoading || isInitLoading',
        color='#27bd8a',
        height='8px',
        width='3px',
        radius='10px'
      )
    .Territory-list(v-if='!isLoading && !isInitLoading')
      report-item.Territory-item.Card(
        v-for='item in list',
        @edit='editDocument(item)',
        @download='download(item)',
        @open='open(item)',
        @remove='removeDocument(item)',
        :key='item.id',
        :item='item',
        :isSelectable='false',
        :isRemovable='$store.getters.permissions.canDeleteControl',
        :isEditable='$store.getters.permissions.canEditControl',
        :isOpenable='item.extension === ".xlsx"'
      )
</template>

<script>
import TerritoryDocument from '@/components/popups/TerritoryDocument'
import ExcelFile from '@/components/popups/ExcelFile'
import common from '@/mixins/common'
import documentSearch from '@/mixins/documentSearch'
import TextBox from '@/components/TextBox.vue'

export default {
  name: 'Control.vue',

  mixins: [common, documentSearch],

  components: {
    TextBox,
    'app-header': () => import('@/components/AppHeader'),
    'fade-loader': () => import('vue-spinner/src/FadeLoader.vue'),
    'report-item': () => import('@/components/reports/ReportItem')
  },

  data() {
    return {
      isLoading: false,
      allowedTypes: ['doc', 'docx', 'txt', 'zip', 'xls', 'xlsx', 'pdf', 'jpg', 'jpeg', 'png', 'rar']
    }
  },

  computed: {
    selectedCount() {
      return this.list.filter((v) => v.isSelected).length
    },
    isInitLoading() {
      return this.$store.getters.isInitLoading
    },
    workspace() {
      return this.$store.getters.workspace
    },
    version() {
      return this.$store.getters.version
    },
    workspaceAndVersion() {
      return { workspace: this.workspace, version: this.version }
    }
  },

  watch: {
    workspaceAndVersion(newVal, oldVal) {
      if (oldVal.workspace && newVal.workspace !== oldVal.workspace) {
        this.$store.dispatch('clearDocuments')
      } else if (oldVal.version && oldVal.version !== newVal.version) {
        this.$store.dispatch('clearDocuments')
      }
      this.getList()
    }
  },

  mounted() {
    this.getList()
  },

  beforeDestroy() {
    this.$store.dispatch('clearDocuments')
  },

  methods: {
    addDocument() {
      this.$ui.popup
        .show({
          component: TerritoryDocument,
          params: {
            width: '734px',
            document: null,
            types: this.allowedTypes,
            docType: 'control'
          }
        })
        .then((r) => {})
        .catch((e) => {})
    },

    editDocument(document) {
      const documentToEdit = {
        ...document,
        file: {
          url: document.file
        }
      }
      this.$ui.popup
        .show({
          component: TerritoryDocument,
          params: {
            width: '734px',
            document: documentToEdit,
            types: this.allowedTypes,
            docType: 'control'
          }
        })
        .then((r) => {
          if (r && r.action === 'remove') {
            this.removeDocument(document)
          }
        })
        .catch((e) => {})
    },

    removeDocument(document) {
      this.$store
        .dispatch('deleteControl', document.id)
        .then((v) => {
          this.$ui.toast.show({ text: 'Документ удален', type: 'success' })
        })
        .catch((e) => {
          this.$store.commit('setApiErrorInfo', 'При удалении документа произошла ошибка')
        })
    },

    getList() {
      if (this.workspace && this.version) {
        this.isLoading = true
        this.$store
          .dispatch('getControlsList')
          .then((r) => {
            this.isLoading = false
          })
          .catch((e) => {
            this.isLoading = false
          })
      }
    },

    open(item) {
      this.$store
        .dispatch('getReportExcelFile', item.file)
        .then((r) => {
          this.$ui.popup
            .show({
              component: ExcelFile,
              params: {
                width: '95%',
                height: '95%',
                blob: r,
                title: item.name
              }
            })
            .then((r) => {})
            .catch((e) => {
              console.log(e)
            })
        })
        .catch((e) => {
          this.$store.commit('setApiErrorInfo', 'Ошибка получения файла')
        })
    },

    download(item) {
      let link = document.createElement('a')
      link.download = name
      link.href = item.file
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style lang="scss">
@import '~base';

#app .Territory {
  --menuLinkColor: #{$blue};
  --menuColor: #{$grey8};
  --selectedText: #{$black5};
}

#app[data-theme='dark'] .Territory {
  --menuLinkColor: #{$blue};
  --menuColor: #{$grey1};
  --selectedText: #{$grey5};
}
</style>
<style scoped lang="scss">
@import '~base';
.Menu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 35px;
  padding: 0 15px;
  color: var(--menuColor);
  border-bottom: 1px solid var(--delimiter);

  label {
    margin-bottom: 0;
  }

  &-left,
  &-right {
    display: flex;
    align-items: center;
  }

  &-item {
    font-size: 12px;

    a {
      display: flex;
      align-items: center;
      color: var(--menuLinkColor);
      font-size: 11px;
      font-weight: 300;
      text-transform: uppercase;
      text-decoration: none;

      .Icon {
        font-size: 14px;
        margin-right: 10px;
      }
    }
  }

  &-delimiter {
    width: 1px;
    height: 24px;
    background: var(--delimiter);
  }
}

.Territory {
  display: flex;
  flex-direction: column;
  height: 100%;

  &-menu {
    flex: 0 0 35px;
  }

  &-spinner {
    position: fixed;
    top: 50%;
    left: 50%;
    margin: -16px 0 0 -16px;
  }

  &-main {
    flex: 1 1 auto;
    padding: 0 15px 50px;
    background: var(--appBg);
    overflow: auto;
  }
  &-list {
    display: flex;
    margin-left: -2%;
    flex-wrap: wrap;
  }
}

.Control {
  &-top-panel {
    justify-content: flex-start;
    gap: 10px;
  }

  &-layer-count {
    flex: 0 0 auto;
    white-space: nowrap;
    padding-top: 3px; /**Чтобы выровнять текст по вертикали со строкой поиска */
  }

  &-search-text-box {
    flex: 0 0 350px;
  }

  &-add-button-wrapper {
    flex: 1 1 auto;
    display: flex;
    justify-content: flex-end;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Control.vue